module.exports = __webpack_public_path__ + "static/media/customer-details.201b4105.png";